import { Form, useNavigate } from 'react-router';

import Dashboard from '~/icons/dashboard.svg'
import CreateEvent from '~/icons/createEvent.svg'

import { UserSession } from '~/data/auth.server'

const UserMenu = ({ user: { name, artist, host } }: { user: UserSession }) => {
  const navigate = useNavigate()

  return (
    <>
      <div className='flex gap-4'>
        <button onClick={() => navigate('/dashboard/user/favourites')}>
          <img src={Dashboard} alt='dashboard_icon' />
        </button>
        <button onClick={() => navigate('/events/create')}>
          <img src={CreateEvent} alt='create_event_icon' />
        </button>
      </div>
      <div className='dropdown'>
        <div className='bg-orange h-userAvatar w-userAvatar rounded-circle flex justify-center items-center'>
          {name[0].toUpperCase()}
        </div>
        <div className='dropdownContent '>
          <button
            className='w-full text-left hover:bg-beige'
            onClick={() =>
              navigate(
                artist === null
                  ? '/artists/create'
                  : `/artists/${artist.profileId}`
              )
            }
          >
            Artist profile
          </button>
          <button
            className='w-full text-left hover:bg-beige'
            onClick={() =>
              navigate(
                host === null ? '/hosts/create' : `/hosts/${host.profileId}`
              )
            }
          >
            Host profile
          </button>
          {host && host.verified && (
            <a
              className='w-full text-left hover:bg-beige'
              href='/recipient/details'
            >
              Bank details
            </a>
          )}
          <Form
            action='/auth/logout'
            method='post'
            className='w-full cursor-pointer hover:bg-beige'
          >
            <button>Logout</button>
          </Form>
        </div>
      </div>
    </>
  )
}

export default UserMenu
